<h1 mat-dialog-title sharedUiModalClose (closed)="dialogRef.close(false)">{{
  data.title
}}</h1>

<ng-scrollbar
  [autoHeightDisabled]="data.autoHeightDisabled ?? false"
  appearance="standard"
  autoWidthDisabled="false"
  class="grow"
>
  <mat-dialog-content>
    @for (
      viewControl of viewControls();
      track viewControl.id;
      let index = $index
    ) {
      <div class="mb-[16px] last:mb-0">
        @switch (viewControl['type']) {
          @case (FormControlTypeEnum.INPUT) {
            @if (form && form.controls[viewControl.id]) {
              <shared-form-input-text
                [testId]="viewControl['testId']"
                [control]="toControl(form.controls[viewControl.id]!)"
                [validationErrors]="viewControl['validation']!.errors"
                [title]="viewControl['title']"
                [tabIndex]="index"
              ></shared-form-input-text>
            }
          }
          @case (FormControlTypeEnum.INPUT_PASSWORD) {
            @if (form && form.controls[viewControl.id]) {
              <shared-form-input-text
                type="password"
                [testId]="viewControl['testId']"
                [control]="toControl(form.controls[viewControl.id]!)"
                [validationErrors]="viewControl['validation']!.errors"
                [title]="viewControl['title']"
                [tabIndex]="index"
              ></shared-form-input-text>
            }
          }
          @case (FormControlTypeEnum.CHECKBOX) {
            @if (form && form.controls[viewControl.id]) {
              <shared-form-input-checkbox
                [testId]="viewControl['testId']"
                [control]="toControl(form.controls[viewControl.id]!)"
                [validationErrors]="viewControl['validation']!.errors"
                [title]="viewControl['title']"
                [tabIndex]="index"
              ></shared-form-input-checkbox>
            }
          }
          @case (FormControlTypeEnum.SELECT) {
            @if (form && form.controls[viewControl.id]) {
              <shared-form-select
                [formControl]="toControl(form.controls[viewControl.id]!)"
                [tabIndex]="index"
                [selectedValue]="$any(viewControl['value'])"
                [options]="viewControl['options'] ?? []"
                [placeholder]="viewControl['placeholder']"
              >
              </shared-form-select>
            }
          }
          @case (FormControlTypeEnum.INPUT_COPY) {
            <shared-ui-copy-text
              [testId]="viewControl['testId']"
              [text]="viewControl['title']!"
              [isCopied]="$any(viewControl['value'])"
            ></shared-ui-copy-text>
          }
          @case (FormControlTypeEnum.LABEL) {
            <div
              class="highlighted py-[5px] text-center text-[15px] leading-[20px]"
              [innerHTML]="viewControl['title']"
            ></div>
          }
          @case (FormControlTypeEnum.INFO_WARNING) {
            <shared-ui-info
              [type]="InfoTypeEnum.WARNING"
              [text]="viewControl['title']"
            ></shared-ui-info>
          }
          @case (FormControlTypeEnum.INFO) {
            <shared-ui-info [text]="viewControl['title']"></shared-ui-info>
          }
          @case (FormControlTypeEnum.COMPONENT) {
            <ng-container
              *ngComponentOutlet="viewControl['view']"
            ></ng-container>
          }
        }
      </div>
    }
  </mat-dialog-content>
</ng-scrollbar>

@if (actions.length > 0) {
  <mat-dialog-actions class="mt-[20px]">
    @for (action of actions; track action.title) {
      @switch (action.type) {
        @case (FormButtonTypeEnum.PRIMARY) {
          <shared-ui-button
            class="flex-1"
            size="stretch"
            [testId]="action.testId"
            [disabled]="action.action ? isSubmitting() || form.invalid : false"
            (clicked)="runAction(action, data.form?.controls)"
            >{{ action.title }}
          </shared-ui-button>
        }
        @case (FormButtonTypeEnum.SECONDARY) {
          <shared-ui-button
            class="flex-1"
            mode="outline"
            size="stretch"
            [testId]="action.testId"
            [disabled]="action.action ? isSubmitting() || form.invalid : false"
            (clicked)="runAction(action)"
            >{{ action.title }}
          </shared-ui-button>
        }
      }
    }
  </mat-dialog-actions>
}
